import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import OurStory from "./pages/Ourstory.js";
import Login from "./pages/Login.js";
import AdminProducts from "./pages/Product.js";
import AdminCategories from "./pages/Categories.js";
import ProtectedRoute from "./components/ProtectedRoute.js";
import ShopDescription from "./pages/ShopDescription.js";
import Cart from "./pages/Cart.js";

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/products/:id" element={<ShopDescription />} />
          <Route path="/story" element={<OurStory />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cart" element={<Cart />} />
          {/* Protected Routes Wrapper */}
          <Route element={<ProtectedRoute />}>
            <Route path="/products" element={<AdminProducts />} />
            <Route path="/categories" element={<AdminCategories />} />
          </Route>
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
